export const onlyNumbers = (str) => /^[0-9]+$/.test(str)
